import React, { useState } from "react"
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { useHistory } from "react-router-dom";
import { Row, Col, Typography, Popover, message } from "antd";
import { ExchangeCurrency, useExcryptedNavigation } from '../../Filters/FilterConditions';
import { FetchUserDetails } from "../../../../Api/Services/UserApiService"
import { FetchAccountDetails } from "../../../../Api/Services/AccountApiService"
import { FetchDealDetails } from "../../../../Api/Services/DealApiService"
import { FetchContactDetails } from "../../../../Api/Services/ContactApiService"
import { LeadDetailData } from "../../../../Api/Services/LeadApiServices"
import { FetchCaseDetails } from "../../../../Api/Services/CaseApiServices"
import { StaffIcon, AccountsIcon } from '../../../../components/Icons/Icons';

const { Text } = Typography;
function findDataByEmail(CaseData, leadData = [], contactData = [], leadList = [], contactList = []) {
    const leadMatchfound = leadData.find(item => item.primaryEmail === CaseData?.caseCreaterEmail);
    if (leadMatchfound) {
        const leadMatch = leadList.find(item => item.leads_id === leadMatchfound.leads_id)
        return {
            type: 'LEAD',
            name: `${leadMatchfound?.first_name} ${leadMatchfound?.last_name}`,
            email: leadMatchfound?.primary_email,
            profilePic: leadMatchfound?.lead_profile,
            id: leadMatch ? leadMatch.leads_id : null,
            sharingId: leadMatch ? leadMatch.fromId : null,
        };
    }
    // Check in contact data (by email)
    const contactMatchfound = contactData.find(item => item.email === CaseData?.caseCreaterEmail);
    if (contactMatchfound) {
        const contactMatch = contactList.find(item => item.contacts_id === contactMatchfound.contacts_id)
        return {
            type: 'CONTACT',
            name: `${contactMatchfound?.first_name} ${contactMatchfound?.last_name}`,
            email: contactMatchfound?.email,
            profilePic: contactMatchfound?.contact_profile,
            id: contactMatch ? contactMatch.contacts_id : null,
            sharingId: contactMatch ? contactMatch.fromId : null,
        };
    }
    return {
        type: 'OTHER',
        name: CaseData?.caseCreater,
        email: CaseData?.caseCreaterEmail,
        profilePic: null,
        id: null,
        sharingId: null
    };
}
const AccountCenterCard = ({ item, index, widths, page }) => {
    const localData = useSelector((state) => state.localRedux)
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    const history = useHistory();
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, null, null, null)
    }
    return (<div className='RightSide-DataShadow' key={index} style={{ marginBottom: page === "Merge" ? 10 : 15, width: widths ? "300px" : "auto" }}>
        <div className="user-info_image" style={{ padding: "0px 0px 10px" }}>
            {item?.account_profile !== null && item?.account_profile
                !== undefined && item?.account_profile !== "" ?
                <figure>
                    <img style={{ width: "30px", height: "30px" }} src={item?.account_profile} alt="" />
                </figure>
                :
                <span className='list_span_Tag AccountIcon'>
                    {item?.account_name?.slice(0, 1).toUpperCase()}
                </span>
            }
            <figcaption>
                <div>{item?.account_name}</div>
                <div style={{ fontSize: 12, color: "#adb4d2" }}>{item?.account_number}</div>
            </figcaption>
        </div>
        <Row gutter={30}>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                {(item?.industry_name && item?.industry_name !== "") ?
                    <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Industry</Text>
                        <br />
                        <Text >{item?.industry_name}</Text>
                    </div> : <></>}</Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                {(item?.nom_of_employees && item?.nom_of_employees !== "") ?
                    <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>No of Employees</Text>
                        <br />
                        <Text >{item?.nom_of_employees}</Text>
                    </div> : <></>}
            </Col>
        </Row>
        <Row gutter={30}>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                {(item?.annual_revenue && item?.annual_revenue !== "") ?
                    <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Annual Revenue</Text> <br />
                        <Text >{item?.annual_revenue}</Text>
                    </div> : <></>}</Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                {(item?.rating && item?.rating !== "") ?
                    <div><Text type="secondary" className='RightSide-Lable'>Rating</Text> <br />
                        <Text >{item?.rating}</Text>
                    </div> : <></>}
            </Col>
        </Row>
        {item?.account_owner &&
            <div><Text type="secondary" className='RightSide-Lable'>Sponsor Owner</Text> <br />
                <Text >
                    <div className={`user-info_image ${(Role === "Administrator" || profile.userId === item?.account_owner) && "ListNavigate"}`}
                        role="button" style={{ padding: "5px 0px 0px" }}
                        tabIndex={0}
                        onClick={(Role === "Administrator" || profile.userId === item?.account_owner) ? () => item?.account_owner && ViewDetailPage(item?.account_owner, "USER") : undefined}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                                ViewDetailPage(item?.account_owner, "USER");
                            }
                        }}> {item?.userProfilePic !== null && item?.userProfilePic
                            !== undefined && item?.userProfilePic !== "" ?
                            <figure>
                                <img style={{ width: "30px", height: "30px" }} src={item?.userProfilePic} alt="" />
                            </figure>
                            :
                            <span className='list_span_Tag UserIcon'>
                                {item?.userFirstName?.slice(0, 1).toUpperCase()}
                            </span>
                        }
                        <figcaption>
                            <div> {`${item?.userFirstName} ${item?.userLastName}`}</div>
                            <div style={{ fontSize: 12, color: "#adb4d2" }}>{item?.accountOwner}</div>
                        </figcaption>
                    </div>
                </Text>
            </div>
        }
    </div>)
}
AccountCenterCard.propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    widths: PropTypes.number,
    page: PropTypes.string,
};
const LeadCenterCard = ({ item, index, widths, page }) => {
    return (<div className='RightSide-DataShadow' key={index} style={{ marginBottom: page === "Merge" ? 10 : 15, width: widths ? "300px" : "auto" }}>
        <div className='user-info_image' style={{ marginBottom: 5 }}
        > {item?.lead_profile !== null && item?.lead_profile
            !== undefined && item?.lead_profile !== "" ?
            <figure>
                <img style={{ width: "30px", height: "30px" }} src={item?.lead_profile} alt="" />
            </figure>
            :
            <span className='list_span_Tag ContactIcon'>
                {item?.first_name?.slice(0, 1).toUpperCase()}
            </span>
            }
            <figcaption>
                <div>
                    {`${item?.first_name} ${item?.last_name}`}
                </div>
                <div className='entityemail'>
                    {item?.primary_email}
                </div>
            </figcaption>
        </div>
        <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
            <StaffIcon height={15} width={15} marginRight={5} />{item?.designation}
        </div>
        <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
            <FeatherIcon icon="phone" size={15} style={{ display: "flex", alignItems: "center", marginRight: 5 }} />
            {(item?.mobile && item?.mobile !== "") ? item?.mobile : <span style={{ visibility: "hidden" }}>0</span>}
        </div>
        <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
            <AccountsIcon height={15} width={15} marginRight={5} />{item?.account_name}
        </div>
    </div>)
}
LeadCenterCard.propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    widths: PropTypes.number,
    page: PropTypes.string,
};
const ContactCenterCard = ({ item, index, widths, page }) => {
    return (<div className='RightSide-DataShadow' key={index} style={{ marginBottom: page === "Merge" ? 10 : 15, width: widths ? "300px" : "auto" }}>
        <div className='user-info_image' style={{ marginBottom: 5 }}
        > {item?.contact_profile !== null && item?.contact_profile
            !== undefined && item?.contact_profile !== "" ?
            <figure>
                <img style={{ width: "30px", height: "30px" }} src={item?.contact_profile} alt="" />
            </figure>
            :
            <span className='list_span_Tag ContactIcon'>
                {item?.first_name?.slice(0, 1).toUpperCase()}
            </span>
            }
            <figcaption>
                <div>
                    {`${item?.first_name} ${item?.last_name}`}
                </div>
                <div className='entityemail'>
                    {item?.email}
                </div>
            </figcaption>
        </div>
        <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
            <StaffIcon height={15} width={15} marginRight={5} />{item?.designation}
        </div>
        <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
            <FeatherIcon icon="phone" size={15} style={{ display: "flex", alignItems: "center", marginRight: 5 }} />
            {(item?.mobile && item?.mobile !== "") ? item?.mobile : <span style={{ visibility: "hidden" }}>0</span>}
        </div>
        <div style={{ marginBottom: 5, display: "flex", alignItems: "center" }}>
            <AccountsIcon height={15} width={15} marginRight={5} />{item?.account_name}
        </div>
    </div >)
}
ContactCenterCard.propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    widths: PropTypes.number,
    page: PropTypes.string,
};
const CaseCenterCard = ({ item, index, widths, ViewDetailPage, }) => { // allContactList, leadList, contactList, allLeadList,
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const ProfileData = localData.profile
    const profile = ProfileData
    return (<div className='RightSide-DataShadow' key={index} style={{ marginBottom: 15, width: widths ? "300px" : "auto" }}>
        <div className="user-info_image" style={{ padding: "0px 0px 10px" }}>
            <span className='list_span_Tag'>
                {item?.caseSubject?.slice(0, 1).toUpperCase()}
            </span>
            <figcaption>
                <div className='div-ellipsis' title={item?.caseSubject}> {item?.caseSubject}</div>
                <div style={{ fontSize: 12, color: "#adb4d2" }}>{item?.caseNumber}</div>
            </figcaption>
        </div>
        <Row gutter={30}>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                {(item?.caseType && item?.caseType !== "") ?
                    <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Case Type</Text> <br />
                        <Text >{item?.caseType}</Text>
                    </div> : <></>}  </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                {(item?.caseStatus && item?.caseStatus !== "") ?
                    <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Case Status</Text> <br />
                        <Text ><div className={`status-text CaseStatus-${item?.caseStatus === "On Hold" ? "OnHold" : item?.caseStatus}`}>{item?.caseStatus}</div></Text>
                    </div> : <></>}</Col>
        </Row>
        <Row gutter={30}>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                {(item?.caseOrigin && item?.caseOrigin !== "") ?
                    <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Case Origin</Text> <br />
                        <Text >{item?.caseOrigin}</Text>
                    </div> : <></>
                }</Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                {(item?.casePriority && item?.casePriority !== "") ?
                    <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Case Priority</Text> <br />
                        <Text >{item?.casePriority}</Text>
                    </div> : <></>
                }
            </Col>
        </Row>
        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Requester</Text> <br />
            <Text> <div className={`user-info_image ${item?.RequesterData?.id && "ListNavigate"}`}
                style={{ padding: "0px 0px 10px" }} tabIndex={0} role="button"
                onClick={item?.RequesterData?.type !== "OTHER" ? () => item?.RequesterData?.id && ViewDetailPage(item?.RequesterData?.id, item?.RequesterData?.type) : undefined}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        ViewDetailPage(item?.RequesterData?.id, item?.RequesterData?.type)
                    }
                }}>
                {item?.RequesterData?.profilePic !== null && item?.RequesterData?.profilePic
                    !== undefined && item?.RequesterData?.profilePic !== "" ?
                    <figure>
                        <img style={{ width: "30px", height: "30px" }} src={item?.RequesterData?.profilePic} alt="" />
                    </figure>
                    :
                    <span className={`list_span_Tag ${item?.RequesterData?.type === "LEAD" ? "LeadIcon" :
                        item?.RequesterData?.type === "CONTACT" ? "ContactIcon" : ""}`}>
                        {item?.RequesterData?.name?.slice(0, 1).toUpperCase()}
                    </span>
                }
                <figcaption>
                    <div> {item?.RequesterData?.name}</div>
                    <div style={{ fontSize: 12, color: "#adb4d2" }}>{item?.RequesterData?.email}</div>
                </figcaption>
            </div></Text>
        </div>
        <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Assignee</Text> <br />
            <Text ><div className={`user-info_image ${(Role === "Administrator" || profile.userId === item?.AssigneeID) && "ListNavigate"}`}
                role="button" style={{ padding: "0px 0px 10px" }}
                tabIndex={0}
                onClick={(Role === "Administrator" || profile.userId === item?.AssigneeID) ? () => item?.AssigneeID && ViewDetailPage(item?.AssigneeID, "USER") : undefined}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        ViewDetailPage(item?.AssigneeID, "USER");
                    }
                }}
            >  {item?.AssigneeProfile !== null && item?.AssigneeProfile
                !== undefined && item?.AssigneeProfile !== "" ?
                <figure>
                    <img style={{ width: "30px", height: "30px" }} src={item?.AssigneeProfile} alt="" />
                </figure>
                :
                <span className='list_span_Tag UserIcon'>
                    {item?.AssigneeName?.slice(0, 1).toUpperCase()}
                </span>
                }
                <figcaption>
                    <div> {item?.AssigneeName}</div>
                    <div style={{ fontSize: 12, color: "#adb4d2" }}>{item?.AssigneeEmail}</div>
                </figcaption>
            </div></Text>
        </div>
    </div >)
}
CaseCenterCard.propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    widths: PropTypes.number,
    ViewDetailPage: PropTypes.func.isRequired,
};
const DealCenterCard = ({ item, index, widths, currecny }) => {
    return (<div className='RightSide-DataShadow' key={index} style={{ marginBottom: 15, width: widths ? "240px" : "auto" }}>
        <div className="user-info_image" style={{ padding: "0px 0px 10px" }}>
            {item?.deal_profile !== null && item?.deal_profile
                !== undefined && item?.account_profile !== "" ?
                <figure>
                    <img style={{ width: "30px", height: "30px" }} src={item?.account_profile} alt="" />
                </figure>
                :
                <span className='list_span_Tag DealIcon'>
                    {item?.deal_name?.slice(0, 1).toUpperCase()}
                </span>
            }
            <figcaption>
                <div>{item?.deal_name}</div>
                <div style={{ fontSize: 12, color: "#adb4d2" }}>{item?.deal_type_name}</div>
            </figcaption>
        </div>
        {(item?.pipeline_stage && item?.pipeline_stage !== "") ?
            <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Pipeline Stage</Text>
                <br />
                <Text ><div className={`table_list_clicks status-text PipeLine${item.pipeline_stage}`}>{item.pipelineStage}</div>
                </Text>
            </div> : <></>}
        {(item?.deal_value !== undefined && item?.deal_value !== null && item?.deal_value !== "") ?
            <div className='Right-side-divs'><Text type="secondary" className='RightSide-Lable'>Deal Value ({currecny?.currency})</Text>
                <br />
                <Text>{`${currecny?.symbol} ${item.deal_value.toLocaleString()}`}</Text>
            </div> : <></>}
    </div>)
}
DealCenterCard.propTypes = {
    item: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    widths: PropTypes.number,
    currecny: PropTypes.object.isRequired,
};
const DetailsOtherInfoAccount = ({ permission }) => {
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const history = useHistory();
    const ViewDetailPage = (id, entity) => { ExcryptedNavigation("Nav", id, entity, history, null, null, null) }
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);

    const isNavigable = permission?.isPresent

    const fetchUserInfo = async () => {
        if (!permission.id || loading || userData) return;
        setLoading(true);
        try {
            const Response = await FetchAccountDetails(permission.id)
            setUserData(Response.data);
        } catch (err) {
            message.error(err)
        } finally {
            setLoading(false);
        }
    };
    const popoverContent = userData
        ? <AccountCenterCard item={userData} index={0} widths={240} />
        : <span>No data found</span>;
    return (
        <>
            <Popover
                content={!isNavigable && !loading ? popoverContent : null}
                destroyTooltipOnHide
                autoAdjustOverflow
                getPopupContainer={() => document.body}
                trigger="hover"
                onOpenChange={(visible) => {
                    if (visible && !isNavigable) {
                        // if (visible) {
                        fetchUserInfo();
                    }
                }}
                overlayClassName="user-popover"
            >
                <div className={`deal_kanban user-info_image ${permission?.isPresent ? "ListNavigate" : "ListNavigate3"}`}
                    role="button"
                    tabIndex={0}
                    onClick={permission?.isPresent ? () => permission.id && ViewDetailPage(permission?.id, "ACCOUNT") : undefined}
                    onKeyDown={(event) => {
                        if (permission?.isPresent && (event.key === 'Enter' || event.key === ' ')) {
                            ViewDetailPage(permission?.id, "ACCOUNT");
                        }
                    }}
                >
                    {permission?.id &&
                        <figcaption>
                            <div style={{ fontWeight: "bold", fontSize: 10, marginBottom: 4, display: "flex", alignItems: "center", gap: 5 }}>
                                <AccountsIcon height={10} width={10} marginRight={0} /> {permission?.name}
                            </div>
                        </figcaption>
                    }</div>
            </Popover>
        </>
    )
}
DetailsOtherInfoAccount.propTypes = {
    permission: PropTypes.object.isRequired,
};
const AccountDetails = ({ permission }) => {
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const history = useHistory();
    const ViewDetailPage = (id, entity) => { ExcryptedNavigation("Nav", id, entity, history, null, null, null) }
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);

    const isNavigable = permission?.isPresent

    const fetchUserInfo = async () => {
        if (!permission.id || loading || userData) return;
        setLoading(true);
        try {
            const Response = await FetchAccountDetails(permission.id)
            setUserData(Response.data);
        } catch (err) {
            message.error(err)
        } finally {
            setLoading(false);
        }
    };
    const popoverContent = userData
        ? <AccountCenterCard item={userData} index={0} widths={300} />
        : <span>No data found</span>;
    return (
        <>
            <Popover
                content={!isNavigable && !loading ? popoverContent : null}
                destroyTooltipOnHide
                autoAdjustOverflow
                getPopupContainer={() => document.body}
                trigger="hover"
                onOpenChange={(visible) => {
                    if (visible && !isNavigable) {
                        // if (visible) {
                        fetchUserInfo();
                    }
                }}
                overlayClassName="user-popover"
            >
                <div className={`user-info_image ${permission?.isPresent ? "ListNavigate" : "ListNavigate3"}`}
                    role="button"
                    tabIndex={0}
                    onClick={permission?.isPresent ? () => permission.id && ViewDetailPage(permission?.id, "ACCOUNT") : undefined}
                    onKeyDown={(event) => {
                        if (permission?.isPresent && (event.key === 'Enter' || event.key === ' ')) {
                            ViewDetailPage(permission?.id, "ACCOUNT");
                        }
                    }}
                >
                    {permission?.id && (permission?.profile !== null && permission?.profile
                        !== undefined && permission?.profile !== "" ?
                        <figure>
                            <img style={{ width: "30px", height: "30px" }} src={permission?.profile} alt="" />
                        </figure>
                        :
                        <span className='list_span_Tag AccountIcon'>
                            {permission?.name?.slice(0, 1).toUpperCase()}
                        </span>
                    )
                    }
                    {permission?.id &&
                        <figcaption>
                            <div>
                                {permission?.name}
                            </div>
                        </figcaption>
                    }
                </div>
            </Popover>
        </>
    )
}
AccountDetails.propTypes = {
    permission: PropTypes.object.isRequired,
};
const DealDetails = ({ permission, currecny }) => {
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const history = useHistory();
    const ViewDetailPage = (id, entity) => { ExcryptedNavigation("Nav", id, entity, history, null, null, null) }
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);

    const isNavigable = permission?.isPresent

    const fetchUserInfo = async () => {
        if (!permission.id || loading || userData) return;
        setLoading(true);
        try {
            const CurencyDecimalPlace = currecny?.decimalOfCurrency;
            const ConvertRate = currecny?.exchangeRate;
            const dealresponse = await FetchDealDetails(permission.id)
            const Response = dealresponse.data
            const CurrecnyDealValue = await ExchangeCurrency(Number(Response.deal_value), ConvertRate)
            const merged = { ...Response, deal_value: Number(CurrecnyDealValue?.toFixed(CurencyDecimalPlace)) };
            setUserData(merged);
        } catch (err) {
            message.error(err)
        } finally {
            setLoading(false);
        }
    };
    const popoverContent = userData
        ? <DealCenterCard item={userData} index={0} widths={240} currecny={currecny} />
        : <span>No data found</span>;
    return (
        <>
            <Popover
                content={!isNavigable && !loading ? popoverContent : null}
                destroyTooltipOnHide
                autoAdjustOverflow
                getPopupContainer={() => document.body}
                trigger="hover"
                onOpenChange={(visible) => {
                    if (visible && !isNavigable) {
                        // if (visible) {
                        fetchUserInfo();
                    }
                }}
                overlayClassName="user-popover"
            >
                <div className={`user-info_image ${permission?.isPresent ? "ListNavigate" : "ListNavigate3"}`}
                    role="button"
                    tabIndex={0}
                    onClick={permission?.isPresent ? () => permission.id && ViewDetailPage(permission?.id, "DEAL") : undefined}
                    onKeyDown={(event) => {
                        if (permission?.isPresent && (event.key === 'Enter' || event.key === ' ')) {
                            ViewDetailPage(permission?.id, "DEAL");
                        }
                    }}
                >
                    {permission?.id && (permission?.profile !== null && permission?.profile
                        !== undefined && permission?.profile !== "" ?
                        <figure>
                            <img style={{ width: "30px", height: "30px" }} src={permission?.profile} alt="" />
                        </figure>
                        :
                        <span className='list_span_Tag DealIcon'>
                            {permission?.name?.slice(0, 1).toUpperCase()}
                        </span>
                    )
                    }
                    {permission?.id &&
                        <figcaption>
                            <div>
                                {permission?.name}
                            </div>
                        </figcaption>
                    }
                </div>
            </Popover>
        </>
    )
}
DealDetails.propTypes = {
    permission: PropTypes.object.isRequired,
    currecny: PropTypes.object.isRequired,
};
const TaskRelatedItem = ({ displayData, key, item, permission, ViewDetailPage, currecny, allCompanyContact, allLeadList, allContactList, allCompanyLead }) => {
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);

    const isNavigable = permission?.isPresent

    const fetchUserInfo = async () => {
        if (!item.id || loading || userData) return;
        setLoading(true);
        try {
            let Response;
            if (displayData?.task_type_name === "Account") {
                const responseData = await FetchAccountDetails(item.id)
                Response = responseData.data
            }
            if (displayData?.task_type_name === "Lead") {
                const responseData = await LeadDetailData(item.id)
                Response = responseData.data
            }
            if (displayData?.task_type_name === "Deal") {
                const CurencyDecimalPlace = currecny?.decimalOfCurrency;
                const ConvertRate = currecny?.exchangeRate;
                const dealresponse = await FetchDealDetails(item.id)
                const datas = dealresponse.data
                const CurrecnyDealValue = await ExchangeCurrency(Number(datas.deal_value), ConvertRate)
                Response = { ...Response, deal_value: Number(CurrecnyDealValue?.toFixed(CurencyDecimalPlace)) };
            }
            if (displayData?.task_type_name === "Contact") {
                const responseData = await FetchContactDetails(item.id)
                Response = responseData.data
            }
            if (displayData?.task_type_name === "Case") {
                const data = await FetchCaseDetails(item.id)
                const userRespone = await FetchUserDetails(data?.data.caseOwner)
                const RequesterResponse = findDataByEmail(data?.data, allCompanyLead, allCompanyContact, allLeadList, allContactList)
                Response = {
                    ...data?.data,
                    AssigneeName: `${userRespone?.data?.firstName} ${userRespone?.data?.lastName}`,
                    AssigneeEmail: userRespone?.data?.email,
                    AssigneeProfile: userRespone?.data?.profilePic,
                    AssigneeID: userRespone?.data?.userId,
                    RequesterData: RequesterResponse,
                    casePresent: data?.allow ? "Yes" : "No",
                    caseLinkType: data?.CaseLinkType
                }

            }
            setUserData(Response);
        } catch (err) {
            message.error(err)
        } finally {
            setLoading(false);
        }
    };
    const popoverContent = userData
        ?
        (displayData?.task_type_name === "Account" ? <AccountCenterCard item={userData} index={0} widths={300} />
            : displayData?.task_type_name === "Lead" ? <LeadCenterCard item={userData} index={0} widths={240} /> :
                displayData?.task_type_name === "Deal" ? <DealCenterCard item={userData} index={0} widths={240} currecny={currecny} /> :
                    displayData?.task_type_name === "Contact" ? <ContactCenterCard item={userData} index={0} widths={240} /> :
                        displayData?.task_type_name === "Case" && <CaseCenterCard item={userData} index={0} widths={240} ViewDetailPage={ViewDetailPage} />)
        : <span>No data found</span>;

    return (
        <Popover
            content={!isNavigable && !loading ? popoverContent : null}
            destroyTooltipOnHide
            autoAdjustOverflow
            getPopupContainer={() => document.body}
            trigger="hover"
            onOpenChange={(visible) => {
                if (visible && !isNavigable) {
                    // if (visible) {
                    fetchUserInfo();
                }
            }}
            overlayClassName="user-popover"
        >
            <div title={item.name} key={key} role="button"
                tabIndex={0}
                style={{ cursor: permission?.isPresent ? "pointer" : "default" }}
                onKeyDown={(event) => {
                    if (permission?.isPresent && (event.key === 'Enter' || event.key === ' ')) {
                        ViewDetailPage(item.id,
                            displayData?.task_type_name === "Account" ? "ACCOUNT"
                                : displayData?.task_type_name === "Lead" ? "LEAD" :
                                    displayData?.task_type_name === "Deal" ? "DEAL" :
                                        displayData?.task_type_name === "Contact" ? "CONTACT" :
                                            displayData?.task_type_name === "Case" && `?${item.entityPermissionType}`)
                    }
                }}
                onClick={permission?.isPresent ? () => ViewDetailPage(item.id, displayData?.task_type_name === "Account" ? "ACCOUNT"
                    : displayData?.task_type_name === "Lead" ? "LEAD" :
                        displayData?.task_type_name === "Deal" ? "DEAL" :
                            displayData?.task_type_name === "Contact" ? "CONTACT" :
                                displayData?.task_type_name === "Case" ? `?${item.entityPermissionType}` : ""
                ) : undefined}>
                {item.profilePic !== null && item.profilePic !== undefined && item.profilePic !== "" ?
                    <span className="image_icon OverLap_images">
                        <img style={{
                            width: '30px',
                            height: '30px',
                            borderRadius: '50%',
                        }}
                            src={item.profilePic} alt="" />
                    </span>
                    //    < figure >
                    //         <img style={{ width: "30px", height: "30px", zIndex: index + 1 }} src={item.profilePic} alt="" />
                    //     </figure>
                    :
                    <span
                        className={`image_icon OverLap_images ${displayData?.task_type_name === "Account" ? "AccountIcon"
                            : displayData?.task_type_name === "Lead" ? "LeadIcon" :
                                displayData?.task_type_name === "Deal" ? "DealIcon" :
                                    displayData?.task_type_name === "Contact" && "ContactIcon"}`}
                    >
                        {item?.name?.slice(0, 1).toUpperCase()}
                    </span >
                    // <span className="image_icon OverLap_images ContactIcon"
                    //     style={{ zIndex: index + 1 }}
                    // >
                    //     {item?.name?.slice(0, 1).toUpperCase()}
                    // </span >
                }
            </div>
        </Popover>
    )
}
TaskRelatedItem.propTypes = {
    displayData: PropTypes.object.isRequired,
    key: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
    permission: PropTypes.object.isRequired,
    ViewDetailPage: PropTypes.func.isRequired,
    currecny: PropTypes.object.isRequired,
    allCompanyContact: PropTypes.array.isRequired,
    allLeadList: PropTypes.array.isRequired,
    allContactList: PropTypes.array.isRequired,
    allCompanyLead: PropTypes.array.isRequired,
};
const TaskRelatedItem1 = ({ displayData, key, item, permission, ViewDetailPage, currecny, allCompanyContact, allLeadList, allContactList, allCompanyLead }) => {
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);

    const isNavigable = permission?.isPresent

    const fetchUserInfo = async () => {
        if (!item.id || loading || userData) return;
        setLoading(true);
        try {
            let Response;
            if (displayData?.task_type_name === "Account") {
                const responseData = await FetchAccountDetails(item.id)
                Response = responseData.data
            }
            if (displayData?.task_type_name === "Lead") {
                const responseData = await LeadDetailData(item.id)
                Response = responseData.data
            }
            if (displayData?.task_type_name === "Deal") {
                const CurencyDecimalPlace = currecny?.decimalOfCurrency;
                const ConvertRate = currecny?.exchangeRate;
                const dealresponse = await FetchDealDetails(item.id)
                const datas = dealresponse.data
                const CurrecnyDealValue = await ExchangeCurrency(Number(datas.deal_value), ConvertRate)
                Response = { ...Response, deal_value: Number(CurrecnyDealValue?.toFixed(CurencyDecimalPlace)) };
            }
            if (displayData?.task_type_name === "Contact") {
                const responseData = await FetchContactDetails(item.id)
                Response = responseData.data
            }
            if (displayData?.task_type_name === "Case") {
                const data = await FetchCaseDetails(item.id)
                const userRespone = await FetchUserDetails(data?.data?.caseOwner)
                const RequesterResponse = findDataByEmail(data?.data, allCompanyLead, allCompanyContact, allLeadList, allContactList)
                Response = {
                    ...data?.data,
                    AssigneeName: `${userRespone?.data?.firstName} ${userRespone?.data?.lastName}`,
                    AssigneeEmail: userRespone?.data?.email,
                    AssigneeProfile: userRespone?.data?.profilePic,
                    AssigneeID: userRespone?.data?.userId,
                    RequesterData: RequesterResponse,
                    casePresent: data?.allow ? "Yes" : "No",
                    caseLinkType: data?.CaseLinkType
                }

            }
            setUserData(Response);
        } catch (err) {
            message.error(err)
        } finally {
            setLoading(false);
        }
    };
    const popoverContent = userData
        ?
        (displayData?.task_type_name === "Account" ? <AccountCenterCard item={userData} index={0} widths={300} />
            : displayData?.task_type_name === "Lead" ? <LeadCenterCard item={userData} index={0} widths={240} /> :
                displayData?.task_type_name === "Deal" ? <DealCenterCard item={userData} index={0} widths={240} currecny={currecny} /> :
                    displayData?.task_type_name === "Contact" ? <ContactCenterCard item={userData} index={0} widths={240} /> :
                        displayData?.task_type_name === "Case" && <CaseCenterCard item={userData} index={0} widths={240} ViewDetailPage={ViewDetailPage} />)
        : <span>No data found</span>;

    return (
        <Popover
            content={!isNavigable && !loading ? popoverContent : null}
            destroyTooltipOnHide
            autoAdjustOverflow
            getPopupContainer={() => document.body}
            trigger="hover"
            onOpenChange={(visible) => {
                if (visible && !isNavigable) {
                    // if (visible) {
                    fetchUserInfo();
                }
            }}
            overlayClassName="user-popover"
        >
            <div title={item.name} key={key} role="button"
                tabIndex={0}
                style={{ cursor: permission?.isPresent ? "pointer" : "not-allowed", display: "flex", alignItems: "center", gap: "8px", marginBottom: 10 }}
                onKeyDown={(event) => {
                    if (permission?.isPresent && (event.key === 'Enter' || event.key === ' ')) {
                        ViewDetailPage(item.id,
                            displayData.task_type_name === "Account" ? "ACCOUNT"
                                : displayData.task_type_name === "Lead" ? "LEAD" :
                                    displayData.task_type_name === "Deal" ? "DEAL" :
                                        displayData.task_type_name === "Contact" ? "CONTACT" :
                                            displayData.task_type_name === "Case" ? `?${item.entityPermissionType}` : "")
                    }
                }}
                onClick={permission?.isPresent ? () => ViewDetailPage(item.id, displayData.task_type_name === "Account" ? "ACCOUNT"
                    : displayData.task_type_name === "Lead" ? "LEAD" :
                        displayData.task_type_name === "Deal" ? "DEAL" :
                            displayData.task_type_name === "Contact" ? "CONTACT" :
                                displayData.task_type_name === "Case" ? `?${item.entityPermissionType}` : ""
                ) : undefined}>
                {item.profilePic !== null && item.profilePic !== undefined && item.profilePic !== "" ? (
                    <img
                        src={item?.profilePic}
                        alt={item?.name}
                        style={{
                            width: '30px',
                            height: '30px',
                            borderRadius: '50%',
                        }}
                    />
                ) : (
                    <span className={`image_icon ${displayData.task_type_name === "Account" ? "AccountIcon"
                        : displayData.task_type_name === "Lead" ? "LeadIcon" :
                            displayData.task_type_name === "Deal" ? "DealIcon" :
                                displayData.task_type_name === "Contact" && "ContactIcon"}`}>
                        {item?.name.slice(0, 1)?.toUpperCase()}
                    </span>
                )}
                <span>{item?.name}</span>
            </div>
        </Popover>
    )
}
TaskRelatedItem1.propTypes = {
    displayData: PropTypes.object.isRequired,
    key: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
    permission: PropTypes.object.isRequired,
    ViewDetailPage: PropTypes.func.isRequired,
    currecny: PropTypes.object.isRequired,
    allCompanyContact: PropTypes.array.isRequired,
    allLeadList: PropTypes.array.isRequired,
    allContactList: PropTypes.array.isRequired,
    allCompanyLead: PropTypes.array.isRequired,
};
const MergeInfoCard = ({ Pagetype, key, item }) => {
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchUserInfo = async () => {
        if (!item.id || loading || userData) return;
        setLoading(true);
        try {
            let Response;
            if (Pagetype === "Accounts") {
                const responseData = await FetchAccountDetails(item.id)
                Response = responseData.data
            }
            if (Pagetype === "Leads") {
                const responseData = await LeadDetailData(item.id)
                Response = responseData.data
            }
            if (Pagetype === "Contacts") {
                const responseData = await FetchContactDetails(item.id)
                Response = responseData.data
            }
            setUserData(Response);
        } catch (err) {
            message.error(err)
        } finally {
            setLoading(false);
        }
    };
    const popoverContent = userData ? (Pagetype === "Accounts" ? <AccountCenterCard item={userData} index={0} widths={300} page="Merge" />
        : Pagetype === "Leads" ? <LeadCenterCard item={userData} index={0} widths={240} page="Merge" /> :
            Pagetype === "Contacts" ? <ContactCenterCard item={userData} index={0} widths={240} page="Merge" /> : "") : <span>No data found</span>;

    return (
        <Popover
            content={!loading && popoverContent}
            trigger="hover"
            destroyTooltipOnHide
            autoAdjustOverflow
            getPopupContainer={() => document.body}
            onOpenChange={(visible) => {
                if (visible) {
                    fetchUserInfo();
                }
            }}
            overlayClassName="user-popover"
        >
            <div title={item.name} key={key} role="button" className="merge-hover"
                tabIndex={0}
                style={{ cursor: "pointer" }}
            >
                {Pagetype === "Accounts" ? item.account_name
                    : Pagetype === "Leads" ? `${item.first_name} ${item.last_name}` :
                        Pagetype === "Contacts" && `${item.first_name} ${item.last_name}`}
            </div>
        </Popover>
    )
}
MergeInfoCard.propTypes = {
    Pagetype: PropTypes.string.isRequired,
    key: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
};
export { AccountCenterCard, DetailsOtherInfoAccount, AccountDetails, DealDetails, DealCenterCard, TaskRelatedItem, LeadCenterCard, ContactCenterCard, CaseCenterCard, MergeInfoCard, TaskRelatedItem1 }